import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: null,
    settings: {
      nearest: true,
      flow_type: "normal",
      ocr_scan: false,
      insurance_fields: {
        carrier_required: false,
        group_number_required: false,
        phone_required: false,
        member_id_required: false,
        employer_name_required: false,
        home_zip_required: false,
        first_name_required: false,
        last_name_required: false,
        birth_date_required: false,
      },
      insurance_enabled: true,
      hide_providers_selection: false,
      confirm_token_expiry_in_min: 90,
    },
    services: [],
    reset: false,
    isComplete: false,
    isError: false,
    locations: [],
    providers: [],
    map: {
      locations: [],
    },
    insurances: [],
    appLoadTime: moment(),
    localEndDate: new Date(),
    meta: {
      didOcrIdScan: false,
      didOcrInsuranceScan: false,
      didOcrSecondaryInsuranceScan: false,
      totalBookingTimeInSeconds: 0,
      idScanResult: null,
      insuranceScanResult: null,
      secondaryInsuranceScanResult: null,
    },
  },
  getters: {
    isAppSet(state) {
      if (state.reset) {
        setTimeout(() => {
          state.reset = false;
        }, 100);
        return false;
      } else {
        return state && state.config && state.config.token;
      }
    },
    isSingleLocation(state) {
      if (!state.config) return;
      return !!state.config.locationId || !!state.config.location_id;
    },
    locationId(state, getters) {
      if (!getters.isSingleLocation) return;
      return state.config.locationId || state.config.location_id;
    },
    flowType(state) {
      return state.settings?.flow_type || "normal";
    },
    insuranceFieldsIsRequired(state) {
      return Object.values(state.settings.insurance_fields).includes(true);
    },
    location(state, getters) {
      const locations = state?.locations;
      if (locations?.length === 0) return;
      return locations.find((el) => el?.location_id == getters?.locationId);
    },
    provider(state) {
      if (state?.providers.length === 0) return;
      return state.providers[0];
    },
    includeServices(state) {
      if (!state?.config) return [];
      if (!state?.config?.includeServices) return [];
      if (!Array.isArray(state.config.includeServices)) return [];
      return (state.config?.includeServices || []).map((el) =>
        (el || "")?.toString()
      );
    },
    useDatePicker(state) {
      if (!state.config) return;
      return !!state.config.useDatePicker || !!state.config.use_date_picker;
    },
    isInsuranceEnabled(state) {
      return state.settings?.insurance_enabled || false;
    },
    hideProvidersSelection(state) {
      return state.settings?.hide_providers_selection || false;
    },
  },
  mutations: {
    fieldUpdate(state, { key, value }) {
      state[key] = value;
    },
    subFieldUpdate(state, { pKey, key, value }) {
      if (!pKey) return;
      state[pKey][key] = value;
    },
    setLocalEndDate(state, date) {
      state.localEndDate = date;
    }
  },
  actions: {
    updateLocalEndDate({ commit }, date) {
      commit("setLocalEndDate", date);
    },
  },
});
